import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";


@Injectable()
export class SchedulerService {
  schedulerAction = new Subject();

  constructor(private httpClient: HttpClient) { }

  sendAction(action, data) {
    return this.schedulerAction.next({ action: action, data: data });
  }

  getAction(): Observable<any> {
    return this.schedulerAction.asObservable();
  }


  getSchedulerLog(sort: string, limit: number, page: number,isCount:boolean): Observable<any> {
    let query = `?sort=${sort}&page=${page}&limit=${limit}`;
    query += isCount ? "&count=1" : "&";
    return this.httpClient.get<any>('scheduler/getSchedules/' + query);
  }

  getMailLog(sort: string, limit: number, page: number,isCount:boolean): Observable<any> {
    let query = `?sort=${sort}&page=${page}&limit=${limit}`;
    query += isCount ? "&count=1" : "&";
    return this.httpClient.get<any>('scheduler/getMailes/' + query);
  }

  deleteScheduler(sid){
    return this.httpClient.delete<any>(`scheduler/${sid}`);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/scheduler/scheduler.service.ts